import clsx from "clsx";
import * as React from "react";

interface FloatingButtonBaseProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: React.ReactNode;
  className?: string;
  size?: "sm" | "md";
  withClose?: boolean;
  classNames?: {
    root?: string;
    icon?: string;
    label?: string;
  };
}

interface WithoutExtendedProps extends FloatingButtonBaseProps {
  variant?: "default";
  label?: never;
}

interface WithExtendedProps extends FloatingButtonBaseProps {
  variant: "extended";
  label: string;
}

type FloatingButtonProps = WithExtendedProps | WithoutExtendedProps;

const FloatingButton = React.forwardRef<HTMLButtonElement, FloatingButtonProps>(
  (
    {
      className,
      icon,
      size = "md",
      variant = "default",
      withClose = false,
      classNames,
      ...rest
    },
    ref,
  ) => {
    const props = rest as FloatingButtonBaseProps;

    return (
      <button
        ref={ref}
        className={clsx(
          "ox-reset",
          "ox-ui-FloatingButton",
          className,
          classNames?.root,
        )}
        {...props}
        data-size={size}
        data-variant={variant}
        data-close={withClose}
      >
        {icon ? (
          <span
            className={clsx(
              "ox-reset",
              "ox-FloatingButtonIcon",
              classNames?.icon,
            )}
          >
            {icon}
          </span>
        ) : null}
        {variant === "extended" && "label" in rest ? (
          <span
            className={clsx(
              "ox-reset",
              "ox-FloatingButtonLabel",
              classNames?.label,
            )}
          >
            {rest.label}
          </span>
        ) : null}
      </button>
    );
  },
);

FloatingButton.displayName = "FloatingButton";

export { FloatingButton };
export type { FloatingButtonProps };
